interface ConstructorOptions {
  preSizing?: boolean;
  pvCurve?: boolean;
}

export class UsageStatus {
  private readonly preSizing: boolean;
  private readonly pvCurve: boolean;

  constructor(options: ConstructorOptions = {}) {
    this.preSizing = options.preSizing ?? true;
    this.pvCurve = options.pvCurve ?? false;
  }

  public isUsedForPreSizing(): boolean {
    return this.preSizing;
  }

  public isUsedForPvCurve(): boolean {
    return this.pvCurve;
  }

  public combine(fieldUsage: UsageStatus) {
    return new UsageStatus({
      preSizing: this.preSizing || fieldUsage.preSizing,
      pvCurve: this.pvCurve || fieldUsage.pvCurve
    });
  }
}
